export const apiAuth = "https://the-holidaze.herokuapp.com/api/auth/local";
export const apiHotels = "https://the-holidaze.herokuapp.com/api/hotels";
export const apiContact = "https://the-holidaze.herokuapp.com/api/contacts";
export const apiEnquiry = "https://the-holidaze.herokuapp.com/api/enquiries";
export const apiRatings = "https://the-holidaze.herokuapp.com/api/ratings";
